<div class="login-container">
  <p class="login-message">Please login with your Google account to use this site</p>
  <div id="loginLoginButtonDiv" class="loginButtonDiv" title="Login Button"></div>
</div>
